import { ChevronDownIcon } from '@langchain/untitled-ui-icons';

import { Button, Text } from '@/design-system';
import { HostListenerSchema } from '@/types/schema';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../Dropdown';

interface HostListenersDropdownProps {
  selectedListener?: HostListenerSchema;
  setSelectedListener: (listener: HostListenerSchema) => void;
  k8sNamespace: string;
  setK8sNamespace: (namespace: string) => void;
  listeners: HostListenerSchema[];
}

export function HostListenersDropdown({
  selectedListener,
  setSelectedListener,
  k8sNamespace,
  setK8sNamespace,
  listeners,
}: HostListenersDropdownProps) {
  return (
    <div className="flex gap-4">
      <div className="flex flex-col gap-1">
        <Text weight="medium">Listener</Text>
        <DropdownMenu>
          <DropdownMenuTrigger>
            <Button
              size="md"
              color="secondary"
              rightDecorator={ChevronDownIcon}
            >
              {selectedListener?.compute_id || 'Select Listener Compute ID'}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            {listeners?.map((listener) => (
              <DropdownMenuItem
                className="flex flex-row items-center gap-2"
                onClick={() => {
                  setSelectedListener(listener);
                }}
              >
                {listener.compute_id}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      {selectedListener && (
        <div className="flex flex-col gap-1">
          <Text weight="medium">Namespace</Text>
          <DropdownMenu>
            <DropdownMenuTrigger>
              <Button
                size="md"
                color="secondary"
                rightDecorator={ChevronDownIcon}
              >
                {k8sNamespace || 'Select Kubernetes Namespace for Listener'}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
              {selectedListener.compute_config.k8s_namespaces?.map(
                (namespace) => (
                  <DropdownMenuItem
                    className="flex flex-row items-center gap-2"
                    onClick={() => {
                      setK8sNamespace(namespace);
                    }}
                  >
                    {namespace}
                  </DropdownMenuItem>
                )
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
    </div>
  );
}
